import React from 'react'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LockIcon } from '@csrc/assets/icons'
import { Link } from 'react-router-dom'

import { trans, getFeature } from '@utils'

const AddGlobalItemInPageRootFeatureComponent = (props: any) => {
  const feature = getFeature('ckl_item_repeater')
  const { onClose } = props
  return (
    <>
      {/* <div className={'d-flex align-items-center'}>
        <FontAwesomeIcon icon={LockIcon} color={'#ea5455'} />
        <span className={'text-danger ml-25'}>{trans('featureComponent.upgradeToAccessImageMarker')}</span>
      </div>
      <h1>{trans('featureComponent.controlImageMarker')}</h1>
      <h2>{trans('featureComponent.byUpgradingYouCan')}</h2>
      <ul className="">
        <li>
          <div className="">{trans('featureComponent.addNewImageMarker')}</div>
        </li>
        <li>
          <div className="">{trans('featureComponent.editYourImageMarker')}</div>
        </li>
      </ul>
      <Button color='primary' target={'_blank'} tag={'a'} href={'/workspace/settings/plans'}>
        <span>{trans('featureComponent.upgradeToPlan', { plan: feature.require })}</span>
      </Button> */}
    </>
  )
}
//************************************//
export default AddGlobalItemInPageRootFeatureComponent
